import { validationTranslationKeys } from '@va/constants';

export const FILTER_SELECTION_MODAL_CLASS_IDENTIFIER = 'filter-selection-modal';

export const filterValidationKeys = {
  required: validationTranslationKeys.required,
  selectAtLeastOneOption: 'filters.validation.selectAtLeastOneOption',
};
